import { render, staticRenderFns } from "./PurchasesPaymentViewGlobal.vue?vue&type=template&id=1296e650"
import script from "./PurchasesPaymentViewGlobal.vue?vue&type=script&lang=js"
export * from "./PurchasesPaymentViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports